import { GetPermitByBasicIDAPI } from "./api";
import { useQuery } from '@tanstack/react-query'

export function useGetPermitByBasicIDQuery(data) {
    let dataCheck = data.BasicDetailID!== null && data.BasicDetailID!== undefined && data.BasicDetailID!== ""
    return useQuery({
      queryKey: ["GetPermitByBasicID", data.BasicDetailID],
      queryFn: () => GetPermitByBasicIDAPI(data),
      gcTime: Infinity,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      enabled : dataCheck
    })
  }